const reference = [
  {
    path: '/approval/box/reference/mealcost',
    component: () => import('@/page/approval/box/reference/MealCostReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/mealcost/detail/:id',
        component: () => import('@/page/approval/box/reference/MealCostReferenceDetail.vue'),
        meta: {
          name: '식대비 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '식대비 참고함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reference/expense',
    component: () => import('@/page/approval/box/reference/ExpenseReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/expense/detail/:id',
        component: () => import('@/page/approval/box/reference/ExpenseReferenceDetail.vue'),
        meta: {
          name: '지출결의서 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '지출결의서 참고함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reference/submit',
    component: () => import('@/page/approval/box/reference/SubmitReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/submit/detail/:id',
        component: () => import('@/page/approval/box/reference/SubmitReferenceDetail.vue'),
        meta: {
          name: '품의서 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '품의서 참고함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reference/holidaywork',
    component: () => import('@/page/approval/box/reference/HolidayWorkReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/holidaywork/detail/:id',
        component: () => import('@/page/approval/box/reference/HolidayWorkReferenceDetail.vue'),
        meta: {
          name: '휴일근무 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '휴일근무 참고함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reference/admit',
    component: () => import('@/page/approval/box/reference/AdmitReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/admit/detail/:id',
        component: () => import('@/page/approval/box/reference/AdmitReferenceDetail.vue'),
        meta: {
          name: '인정휴가 지급 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '인정휴가 지급 참고함',
      isMenu: false,
    },
  },
  {
    path: '/approval/box/reference/businesstrip',
    component: () => import('@/page/approval/box/reference/BusinessTripReferenceList.vue'),
    children: [
      {
        path: '/approval/box/reference/businesstrip/detail/:id',
        component: () => import('@/page/approval/box/reference/BusinessTripReferenceDetail.vue'),
        meta: {
          name: '출장결과보고서 참조 상세',
          isMenu: false,
        },
      },
    ],
    meta: {
      name: '출장결과보고서 참고함',
      isMenu: false,
    },
  },
];

export default reference;
